import MineBanner from '@/public/assets/images/mines/mine-banner.png'
import GemBanner from '@/public/assets/images/mines/gem-banner.png'
import { SimpleGrid, Box, Text } from '@chakra-ui/react'
import Image from 'next/image'
import { useTranslation } from 'next-i18next/pages'

export const NumberOfMines = ({ numberOfMines, isVertical }: { numberOfMines: number; isVertical?: boolean }) => {
  return (
    <SimpleGrid gap={2} columns={isVertical ? { base: 2, sm: 1 } : 2} fontWeight={700}>
      <NumberOfMinesElement number={numberOfMines} type={'MINES'} isVertical={isVertical} />
      <NumberOfMinesElement number={25 - numberOfMines} type={'GEMS'} isVertical={isVertical} />
    </SimpleGrid>
  )
}

const NumberOfMinesElement = ({
  number,
  type,
  isVertical = false,
}: {
  number: number
  type: 'MINES' | 'GEMS'
  isVertical?: boolean
}) => {
  const { t } = useTranslation()
  const isMine = type === 'MINES'

  return (
    <Box overflow={'hidden'} rounded={'xl'} pos={'relative'}>
      <Box
        right={isVertical ? { base: 0, sm: '-22px' } : 0}
        bottom={isVertical ? { base: 0, sm: isMine ? '22px' : '7px' } : 0}
        height={isVertical ? { base: 'full', sm: '58px' } : 'full'}
        width={isVertical ? { base: 'auto', sm: '102px' } : 'auto'}
        sx={{
          '> img': {
            h: 'full',
            w: 'auto',
          },
        }}
        pos={'absolute'}
        transform={isVertical ? { base: 'none', sm: 'rotate(90deg)' } : 'none'}
        transformOrigin={'prose'}
      >
        {isMine ? <Image src={MineBanner} alt={''} /> : <Image src={GemBanner} alt={''} />}
      </Box>
      <Box
        zIndex={10}
        pos={'relative'}
        h={'full'}
        boxShadow={isMine ? '0px -2px 20px 0px #FF1B1B inset' : '0px -4px 20px 0px #4AF05D inset;'}
        pl={3}
        py={2}
        justifyContent={'start'}
        gap={1}
        alignItems={'end'}
        display={{ base: 'flex', sm: 'block' }}
      >
        <Text lineHeight={1.15} fontSize={'xl'}>
          {number}
        </Text>
        <Text fontSize={'xs'} color={'ninja.100'}>
          {isMine ? t('common.mines') : t('common.gems')}
        </Text>
      </Box>
    </Box>
  )
}
